import { render, staticRenderFns } from "./Dashboard2.vue?vue&type=template&id=d3bd2042"
import script from "./Dashboard2.vue?vue&type=script&lang=js"
export * from "./Dashboard2.vue?vue&type=script&lang=js"
import style0 from "./Dashboard2.vue?vue&type=style&index=0&id=d3bd2042&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports